import * as WebBrowser from 'expo-web-browser';
import * as React from 'react';
import { Alert, Platform, StyleSheet, ToastAndroid } from 'react-native';
import {
  Box,
  Heading,
  Center,
  Stack,
  Spacer,
  Button,
  ChevronRightIcon,
  Radio,
  Text,
  FormControl,
  Input,
  VStack,
  KeyboardAvoidingView,
  ScrollView,
  HStack
} from 'native-base';
import { FormContext } from '../../stores/Store.tsx';
import PreLoader from '../../components/PreLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { isFormEnded } from '../../hooks/isFormEnd';

var numeral = require('numeral');


export default function TrailerBaseScreen(props) {
  const { navigation } = props;
  let [form, setForm] = React.useContext(FormContext);
  const [formData, setFormData] = React.useState({});
  const [working, setWorking] = React.useState(false);

  const handleChange = (data) => {
    setFormData((prev) => {
      return {
        ...prev, ...data
      }
    });
  }
  const handleChangeForm = (data) => {
    const formData = { ...form }
    formData.questions.trailer_base = { data, order: 13 };
    console.log(formData);
    setForm({ ...form, ...formData });
  }

  const continueForm = () => {
    handleChangeForm(formData)
    if (formData.strange_object_trailer_base.value || formData.spareribs_not_visible_trailer_base.value || formData.different_material_trailer_base.value) {
      setWorking(true)
      form.endAt = new Date();
      isFormEnded(() => navigation.navigate('HomeScreen'), form)
    } else {
      navigation.navigate('DoorsScreen')
    }

  }


  if (working) {
    return <PreLoader />;
  }


  return (
    <Center flex={1}>
      <SafeAreaView style={{ flex: 1, padding: 10 }}>
        <KeyboardAvoidingView
          h={{
            // base: "400px",
            lg: "auto",
          }}
          behavior={Platform.OS === "ios" ? "padding" : "height"}
        >
          <VStack
            rounded="lg"
            overflow="hidden"
            width={{
              base: 'xs',
              sm: 'xl',
              md: 768,
              lg: 992,
              xl: 1280,
            }}
            height="full"
            shadow={1}
            _light={{ backgroundColor: 'gray.50' }}
            _dark={{ backgroundColor: 'gray.700' }}
            flex="1"
            justifyContent="flex-end"
          >
            <ScrollView
              _contentContainerStyle={{
                px: "20px",
                mb: "4",
                minW: "72",
              }}
            >
              <Stack p="4" space={3}>
                <Stack space={2}>
                  <Heading size="md" ml="-1">
                    {`Inspector: ${form.inspector}`}
                  </Heading>
                </Stack>
                <Text fontWeight="400">
                  {`Criterios para evaluar las preguntas siguientes responde `}
                  <Text fontWeight="bold">SI </Text>
                  <Text >o</Text>
                  <Text fontWeight="bold"> NO </Text>
                  {`según corresponda`}
                </Text>
                <Text fontWeight="400">
                  {`13) Base del remolque`}
                </Text>
                <FormControl>
                  <Stack space={2}>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>Al utilizar el espejo de inspección se detecta algún artefacto sospechoso adherido a la base
                        </FormControl.Label>
                        <Radio.Group
                          name="strange_object_trailer_base"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ strange_object_trailer_base: { value: nextValue, q: 'Al utilizar el espejo de inspección se detecta algún artefacto sospechoso adherido a la base', critic: true } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.strange_object_trailer_base.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>No se observan las costillas de la base del remolque</FormControl.Label>
                        <Radio.Group
                          name="spareribs_not_visible_trailer_base"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ spareribs_not_visible_trailer_base: { value: nextValue, q: 'No se observan las costillas de la base del remolque', critic: true } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.spareribs_not_visible_trailer_base.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl>
                      <Stack>
                        <FormControl.Label>La base se encuentra agrietada o con enmendaduras</FormControl.Label>
                        <Radio.Group
                          name="amendments_trailer_base"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ amendments_trailer_base: { value: nextValue, q: 'La base se encuentra agrietada o con enmendaduras' } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.amendments_trailer_base.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl>
                      <Stack>
                        <FormControl.Label>Se detecta doble fondo o algún compartimiento secreto
                        </FormControl.Label>
                        <Radio.Group
                          name="secret_compartment_trailer_base"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ secret_compartment_trailer_base: { value: nextValue, q: 'Se detecta doble fondo o algún compartimiento secreto' } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.secret_compartment_trailer_base.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>Se observa un cambio evidente en los materiales (pintura, se vea más nuevo u otro tipo de textura, etc...)
                        </FormControl.Label>
                        <Radio.Group
                          name="different_material_trailer_base"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ different_material_trailer_base: { value: nextValue, q: 'Se observa un cambio evidente en los materiales (pintura, se vea más nuevo u otro tipo de textura, etc...)', critic: true } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.different_material_trailer_base.observations = text} placeholder="Observaciones" />
                    </Stack>
                  </Stack>
                </FormControl>
              </Stack>
            </ScrollView>
            <Spacer />
            <Box>
              <HStack>
                <Spacer />
                <Button
                  disabled={formData.amendments_trailer_base === undefined ||
                    formData.strange_object_trailer_base === undefined ||
                    formData.spareribs_not_visible_trailer_base === undefined ||
                    formData.different_material_trailer_base === undefined ||
                    formData.secret_compartment_trailer_base === undefined
                  }
                  rightIcon={<ChevronRightIcon color="white" />}
                  colorScheme={formData.amendments_trailer_base !== undefined &&
                    formData.strange_object_trailer_base !== undefined &&
                    formData.spareribs_not_visible_trailer_base !== undefined &&
                    formData.different_material_trailer_base !== undefined &&
                    formData.secret_compartment_trailer_base !== undefined
                    ? "info" : "gray"
                  }
                  size="md"
                  onPress={() => continueForm()}
                >
                  Continuar
                </Button>
              </HStack>

            </Box>
          </VStack>
        </KeyboardAvoidingView>
      </SafeAreaView>
    </Center>
  );
}
